var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5795 0C8.76771 0 0 8.76771 0 19.5795C0 30.3913 8.76771 39.159 19.5795 39.159C30.3913 39.159 39.159 30.3913 39.159 19.5795C39.159 8.76771 30.3913 0 19.5795 0ZM29.1617 20.069L22.9746 26.2561C22.7044 26.5302 22.2658 26.5302 21.9956 26.264C21.9956 26.264 21.9917 26.26 21.9878 26.2561C21.7215 25.982 21.7215 25.5434 21.9878 25.2693L26.9923 20.2765H10.479C10.0952 20.2726 9.78976 19.9633 9.78976 19.5795C9.78584 19.1997 10.0874 18.8903 10.4672 18.8864C10.4711 18.8864 10.475 18.8864 10.479 18.8864H26.9923L21.9878 13.878C21.6863 13.643 21.6354 13.2044 21.8703 12.9029C22.1053 12.6014 22.5439 12.5505 22.8454 12.7854C22.8963 12.8246 22.9394 12.8677 22.9746 12.9186L29.1617 19.1057C29.428 19.3681 29.428 19.7988 29.1617 20.0651V20.069Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.9e5b3cb80501b7abf089f964c1d53695.svg";
export { ForwardRef as ReactComponent };